import type { User } from 'firebase/auth';

/**
 * Get list of admin emails from environment variable
 * Format: comma-separated list of email addresses
 */
const getAdminEmails = (): string[] => {
  const adminEmailsEnv = import.meta.env.VITE_ADMIN_EMAILS;
  if (!adminEmailsEnv) {
    return [];
  }
  
  return adminEmailsEnv
    .split(',')
    .map(email => email.trim().toLowerCase())
    .filter(email => email.length > 0);
};

/**
 * Check if a user is an admin based on their email address
 * @param user - Firebase User object or null
 * @returns true if user email matches admin list
 */
export const isAdminUser = (user: User | null): boolean => {
  if (!user || !user.email) {
    return false;
  }
  
  const adminEmails = getAdminEmails();
  if (adminEmails.length === 0) {
    return false;
  }
  
  const userEmail = user.email.toLowerCase().trim();
  return adminEmails.includes(userEmail);
};

/**
 * Check if we're running in localhost (for additional safety)
 * This can be used as an additional check if needed
 */
export const isLocalhost = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  return window.location.hostname === 'localhost' || 
         window.location.hostname === '127.0.0.1' ||
         window.location.hostname === '[::1]';
};

